import { ErrorBoundary } from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { RootErrorBoundary } from './modules/router/components';
import { queryClient } from './services/queryClient';

async function bootstrap() {
  /**
   * Start MSW only in Vite dev server.
   * Built dev deployments also use VITE_ENV=development, but must keep the PWA service worker in control.
   * Otherwise the mockServiceWorker intercepts the requests and the PWA never updates.
   **/
  if (
    import.meta.env.DEV &&
    import.meta.env.VITE_ENV === 'development' &&
    import.meta.env.VITE_MOCK_ENDPOINTS === 'true'
  ) {
    try {
      const { startMockWorker } = await import('./mocks/start');
      await startMockWorker();
    } catch (error) {
      console.error('Failed to start MSW worker', error);
    }
  }

  const rootElement = document.querySelector('#root');
  if (!rootElement) {
    throw new Error(
      'Root element "#root" not found in the document. Check index.html.',
    );
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary fallback={<RootErrorBoundary type="generic" />}>
          <App />
        </ErrorBoundary>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

void bootstrap();
